import { Subtype } from 'types/file.types';
import { LightboxSettings } from 'types/lightbox.types';
import { Slide } from 'yet-another-react-lightbox';
import useActions from './useActions';

const useLightbox = () => {
    const { remove, show, changeCurrentIndex } = useActions();

    const handleShow = (
        url: string | string[],
        { hideDownload, hideZoom, showRotate, subtype: providedSubtype, initialIndex: index }: LightboxSettings = {
            hideDownload: false,
            hideZoom: false,
            showRotate: true
        }
    ) => {
        const slides: (Slide & { id?: string })[] = [];
        if (typeof url === 'string') {
            const subtype = providedSubtype || (url.split(/[#?]/)[0].split('.').pop()!.trim() as Subtype).toLowerCase();
            const name = url.substring(url.lastIndexOf('/') + 1);

            slides.push({ src: url, subtype, download: { filename: name, url } });
        } else
            for (const image of url) {
                const subtype = providedSubtype || (image.split(/[#?]/)[0].split('.').pop()!.trim() as Subtype).toLowerCase();
                const name = image.substring(url.lastIndexOf('/') + 1);
                slides.push({ src: image, subtype, download: { filename: name, url: image } });
            }
        show({ slides, hideDownload, hideZoom, showRotate, initialIndex: index });
    };

    type UrlObject = {
        url: string;
        id?: string;
    };

    const handleShowExtended = (
        urlObject: UrlObject | UrlObject[],
        { hideDownload, hideZoom, showRotate, subtype: providedSubtype, initialIndex: index }: LightboxSettings = {
            hideDownload: false,
            hideZoom: false,
            showRotate: true
        }
    ) => {
        const slides: (Slide & { id?: string })[] = [];
        if (!Array.isArray(urlObject)) {
            const { url, id } = urlObject;
            const subtype = providedSubtype || (url.split(/[#?]/)[0].split('.').pop()!.trim() as Subtype).toLowerCase();
            const name = url.substring(url.lastIndexOf('/') + 1);

            slides.push({ src: url, id, subtype, download: { filename: name, url: url } });
        } else
            for (const image of urlObject) {
                const { url, id } = image;
                const subtype = providedSubtype || (url.split(/[#?]/)[0].split('.').pop()!.trim() as Subtype).toLowerCase();
                const name = url.substring(url.lastIndexOf('/') + 1);
                slides.push({ src: url, id, subtype, download: { filename: name, url: url } });
            }

        show({ slides, hideDownload, hideZoom, showRotate, initialIndex: index });
    };

    const handleRemove = () => {
        remove();
    };

    return { show: handleShow, showExtended: handleShowExtended, remove: handleRemove, changeCurrentIndex };
};

export default useLightbox;
